module.exports = __webpack_public_path__ + "img/jisushenhe.1e17a126.png";